<template>
    <div class="login-box" :class="[type, { borderless: noBorders }]">
        <span class="login-box__log-in" v-html="$t('Login.log_in')"></span>

        <div>
            <TotemButton color="secondary" class="login-box__button-office365" icon="spinner" fullWidth v-if="isProcessingSSORequest" />
            <TotemButton @click="requestSSOLogin('microsoft')" fullWidth color="secondary" class="login-box__button-office365" :label="$t('Login.log_in_sso-office365')" v-else>
                <img src="@/assets/images/microsoft-icon.svg" alt="" />
            </TotemButton>
            <span class="login-box__sso-instructions" v-html="$t('Login.log_in_sso-instructions')"></span>
        </div>
        <div v-if="eduhouseSSOEnabled">
            <span class="login-box__sso-instructions">Click here to login with mock SSO</span>
            <TotemButton :fullWidth="true" color="secondary" class="login-box__button-office365" icon="spinner" v-if="isProcessingSSORequest" />
            <TotemButton @click="requestSSOLogin('eduhouse_mock_sso')" fullWidth color="secondary" class="login-box__button-office365" label="Login with Eduhouse" v-else>
                <img class="login-box__login-sso-button-icon eduhouse-logo" src="@/assets/images/icons/eduhouse.svg" />
            </TotemButton>
        </div>

        <div class="login-box__options-divider">
            <span class="login-box__options-divider-line"></span>
            <span class="login-box__options-divider-label" v-html="$t('Login.log_in_divider-label')"></span>
            <span class="login-box__options-divider-line"></span>
        </div>

        <div class="login-box__main-section">
            <TotemInput tabindex="1" name="username" autocomplete="username" type="text" :label="$t('General.email')" isRequired v-model="model.email" class="login-box__input" @keyup.enter.native="loginUser" />
            <TotemPasswordInput tabindex="1" name="password" autocomplete="password" type="password" :label="$t('General.password')" isRequired v-model="model.password" class="login-box__password-input" @keyup.enter.native="loginUser" />
            <div class="login-box__error" v-if="error">
                <span class="login-box__error-message-icon icon-notification"></span>
                <span class="login-box__error-message">{{ error }}</span>
            </div>
            <TotemButton
                color="primary"
                class="login-box__button"
                icon="spinner"
                :fullWidth="true"
                v-if="isProcessingLogin"
            />
            <TotemButton
                @click="loginUser"
                color="primary"
                class="login-box__button"
                :label="$t('Login.log_in')"
                :fullWidth="true"
                v-else
            />
            <router-link :to="{name:'new-password'}" class="login-box__forgot-password">{{ $t("Login.forgot_password") }}</router-link>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { getDefaultLoggedInRoute } from '@/routes'
    import config from 'services/config'

    export default {
        name: 'login-sso',
        props: {
            noBorders: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                validator: (prop) => ['dropdown-login', 'login-page'].includes(prop),
                default: 'dropdown-login'
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                previousPathBeforeLogin: 'getPreviousPathBeforeLogin'
            })
        },
        methods: {
            async loginUser () {
                this.error = null
                try {
                    this.isProcessingLogin = true
                    await this.setPreviousPathBeforeLoginIfEmpty()
                    await this.$store.dispatch('login', this.model)
                    this.isProcessingLogin = false
                } catch (e) {
                    console.log(e)
                    this.error = e
                    this.isProcessingLogin = false
                }
            },
            async requestSSOLogin (serviceId) {
                this.error = null
                try {
                    this.isProcessingSSORequest = true
                    await this.setPreviousPathBeforeLoginIfEmpty()
                    this.SSOLoginUrl = await this.$store.dispatch('requestSSOLoginUrl', serviceId)
                    location.assign(this.SSOLoginUrl)
                } catch (e) {
                    this.error = this.$t('Login.log_in_sso-general-error')
                    this.isProcessingSSORequest = false
                }
            },
            async setPreviousPathBeforeLoginIfEmpty () {
                if (!this.previousPathBeforeLogin && this.$route.name !== 'free-subscriptions-thank-you') {
                    await this.$store.dispatch('setPreviousPathBeforeLogin', this.$route.fullPath)
                }
            }
        },
        data () {
            return {
                model: {
                    email: null,
                    password: null
                },
                error: null,
                SSOLoginUrl: null,
                isProcessingLogin: false,
                isProcessingSSORequest: false,
                eduhouseSSOEnabled: config.eduhouseSSOEnabled
            }
        },
        created () {
            if (this.isLoggedIn) {
                this.$router.push(getDefaultLoggedInRoute())
            }
        }
    }
</script>

<style lang="scss" scoped>
    .login-box {
        width: 424px;
        flex-direction: column;
        margin: 0 auto;
        border: solid $steam 1px;
        background-color: $white;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        font-family: Nunito-Regular, sans-serif;
        padding: 30px;

        &.login-page {
            border: none;
            box-shadow: none;
        }

        &.borderless {
            border: none;
        }

            [class*="mobile_sm"] & {
                width: 100%;
            }

        &__main-section {
            padding: 0 0 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        &__log-in {
            font-size: 2.4rem;
            font-family: Quicksand-Medium, sans-serif;
            margin: 0 0 30px;
            display: flex;
            justify-self: center;
        }


        &__other-options {
            padding: 15px 0 0
        }

        &__login-spinner {
            padding: 0 !important;
            color: $black;
        }

        &__forgot-password {
            font-family: PlusJakartaSans-Medium, sans-serif;
            font-size: 1.6rem;
            margin: 20px 0 10px;
            color: $lavender;
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        }

        &__options-divider {
            display: flex;
            justify-content: center;
            width: 200px;
            margin: 40px auto 20px;
        }

        &__options-divider-line {
            border-top: 1px solid $tuatara;
            width: 100%;
        }

        &__options-divider-label {
            font-family: PlusJakartaSans-Medium, sans-serif;
            font-size: 2.2rem;
            color: $tuatara;
            position: relative;
            bottom: 13px;
            padding: 0 10px;
        }

        &__sso-instructions {
            font-family: PlusJakartaSans-Regular, sans-serif;
            font-size: 1.4rem;
            display: flex;
            justify-content: center;
            margin: 20px 0;
            line-height: 150%;
        }

        &__input {
            margin: 0 0 20px;
            width: 100% !important;
        }

        &__password-input {
            margin: 0 0 10px;
            width: 100% !important;
        }

        &__button {
            justify-self: center;
            margin: 20px 0 0;
        }

        &__button-office365 {
            align-self: center;
            width: 100%;
        }

        &__login-sso-button-label {
            display: flex;
            align-items: center;
        }

        &__login-sso-button-icon {
            margin: 0 5px 0 0;
        }

        &__login-sso-button-icon.eduhouse-logo {
            width: 2rem;
        }

        &__error {
            color: $chestnut;
            display: flex;
            align-items: flex-start;
            align-self: flex-start;
            font-family: PlusJakartaSans-Medium, sans-serif;
            font-size: 1.4rem;
            gap: 6px;
        }

        &__error-message-icon {
            margin: 2px 0 0;
        }
    }
</style>
